// extracted by css-extract-rspack-plugin
var _1 = "avatar-ZZA3Io";
var _2 = "avatar-popover-Q_8F1t";
var _3 = "avatar-popover-header-_4BqIq";
var _4 = "avatar-popover-title-VytpQJ";
var _5 = "avatar-popover-Q_8F1t";
var _6 = "avatar-popover-header-_4BqIq";
var _7 = "avatar-popover-title-VytpQJ";
export { _1 as "avatar", _2 as "avatar-popover", _3 as "avatar-popover-header", _4 as "avatar-popover-title", _5 as "avatarPopover", _6 as "avatarPopoverHeader", _7 as "avatarPopoverTitle" }
